module.exports = __webpack_public_path__ + "static/img/pc-sns.efba4b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pc-sns.png
// module id = 9iyf
// module chunks = 1